export default {
  error: {
    error404Subtitle: 'Oops! You\'re lost.',
    error404Title: 'The page you are looking for was not found.'
  }
}



// WEBPACK FOOTER //
// ./src/ErrorPage/langs/en_us/index.js